import { Component, OnInit, Input } from '@angular/core';
import {FormGroup} from '@angular/forms';
import { queryProcessor } from '../../model/dynamicForm/queryProcessor';
import { StandardUIService } from '../../services/standardui-service/standardui-service';

@Component({
  selector: 'app-query-builder-dynamic-forms',
  templateUrl: './query-builder-dynamic-forms.component.html',
  styleUrls: ['./query-builder-dynamic-forms.component.scss']
})
export class QueryBuilderDynamicFormsComponent implements OnInit {

  @Input() query: queryProcessor<any>;
  @Input() form: FormGroup;
  pickListArray = [];
  options = [];

  get isValid() { 
    // console.log(this.form.controls);
    // console.log(this.query);

    if(this.query != undefined && this.form.controls[this.query.placeHolder]) {
      return this.form.controls[this.query.placeHolder].valid; 
    } else {
      // console.log('no query found');
    }
    
  }
  
  constructor() { 
    
  }

  ngOnInit() {
    if(this.query && this.query.dataType == "PickList") {
      //console.log(this.query);
      this.pickListArray = this.query.picklistvaluesv1;
      //console.log(this.pickListArray);
      // for(let key in this.pickListArray){
      //    this.options.push({
      //     "key" : key.split('_')[1],
      //     "value": this.pickListArray[key]
      //    });
      // }  
      // if(this.options){
      //   this.options.sort(this.SortByName);
      // }
      
      for(let key in this.pickListArray){
        if(this.pickListArray[key].active===true || this.pickListArray[key].active===''){
            this.options.push({
              "key" : key.split('_')[1],
              "value": this.pickListArray[key].value
            });
          }
      }
      if(this.options){
        this.options.sort(this.SortByName);
      }
      //console.log(this.options);
    }
  }
  SortByName(x,y) {
    return ((x.value == y.value) ? 0 : ((x.value > y.value) ? 1 : -1 ));
  } 
}
